<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const disableMoveButton = ref(true)
const waitRetryTime = 1000 * 60

const moveHome = () => {
  router.replace({ name: 'Home' })
}
setTimeout(() => {
  disableMoveButton.value = false
}, waitRetryTime)
</script>

<template>
  <div class="serverError">
    <div class="serverError__icon">
      <v-icon
        icon="fa-database"
        class="serverError__icon-database"
      />
      <div class="serverError__icon-xmark">
        <v-icon icon="fa-xmark" />
      </div>
    </div>
    <div class="serverError__body">
      <h2 class="serverError__title">
        サーバーで問題が発生しました
      </h2>
      <p class="serverError__message">
        サーバーで問題が発生しているためページの表示ができません。
        60秒後に「ホームへ」ボタンが有効になりますので、やり直しをお願いいたします。
      </p>
      <button
        type="button"
        :disabled="disableMoveButton"
        class="serverError__button c-button c-button--border c-button--border c-button--medium"
        @click="moveHome"
      >
        ホームへ
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.serverError{
  &__icon{
    height: 200px;
    width: 200px;
    position: relative;
    background: var(--frameColor);
    border-radius: 100%;
    margin: 0 auto 30px;
    box-shadow: 0 0 1px rgb(0 0 0 / 50%), 0 0 3px rgb(0 0 0 / 20%);
  }

  &__icon-database{
    height: 100px;
    width: 100px;
    display: block;
    margin: auto;
    position: absolute;
    inset: 0;
  }

  &__icon-xmark{
    background: #FFF;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 2px solid #dd2121;
    position: absolute;
    bottom: 42px;
    right: 54px;

    &::v-deep(svg){
      width: 28px;
      height: 18px;
      color: #dd2121;
    }
  }

  &__title{
    color: #dd2121;
    margin: 20px;
    text-align: center;
    font-size: 1.6rem;
  }

  &__button{
    margin-top: 30px;
  }
}
</style>
